import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import MainLayout from '../../components/mainlayout';
import Topbar from '../../components/topbar';
const Profile = () => {
  return (
    <MainLayout>
        <Box>
        <Topbar title={'Profile'} />
        <Flex
          flex={1}
          direction={"column"}
          h={"100%"}
          w={"100%"}
          bg={"#f8fbff"}
          p={10}
          gridRowGap={6}
          position={"relative"}
        >
            
        </Flex>
        </Box>
    </MainLayout>
  );
};
export default Profile;
